import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const ImageBig = ({ image }) => {
  const base = 'relative w-full lg:w-auto mx-auto lg:m-0 md:flex-[1.75] basis-0 md:max-w-[510px] aspect-[3/4]'
  return (
    <div className={base}>
      <Image
        src={urlForImage(image).url()}
        alt={image.alt}
        fill
        placeholder="blur"
        blurDataURL={image.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default ImageBig
